import { useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

/**
 * ReCaptchaService: A headless component that encapsulates the reCAPTCHA v3 hook.
 * This pattern ensures that the hook is only called within a valid Provider context.
 */
const ReCaptchaService = ({ onReady }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    if (executeRecaptcha) {
      // Pass the execution function back to the parent component
      onReady(() => executeRecaptcha);
    }
  }, [executeRecaptcha, onReady]);

  return null; // Invisible service component
};

export default ReCaptchaService;
